import React from "react";
import {
  formatPostDate,
  getSearchExcerpt,
  getSearchResultTypeLabel,
} from "./searchUtils";
import {
  SearchResultAnalyst,
  SearchResultCard,
  SearchResultDate,
  SearchResultExcerpt,
  SearchResultLink,
  SearchResultMeta,
  SearchResultTitle,
  SearchResultType,
} from "./Search.styles";

const SearchResultCardItem = ({ post }) => {
  const authorName = post?.author?.name || "Unknown analyst";

  return (
    <SearchResultLink to={post.url}>
      <SearchResultCard>
        <SearchResultMeta>
          <SearchResultType>{getSearchResultTypeLabel(post)}</SearchResultType>
          <SearchResultAnalyst>{authorName}</SearchResultAnalyst>
          <SearchResultDate>
            <span className="material-icons" aria-hidden="true">
              event
            </span>
            {formatPostDate(post.publishedAt)}
          </SearchResultDate>
        </SearchResultMeta>
        <SearchResultTitle>{post.title}</SearchResultTitle>
        {getSearchExcerpt(post) && (
          <SearchResultExcerpt>{getSearchExcerpt(post)}</SearchResultExcerpt>
        )}
      </SearchResultCard>
    </SearchResultLink>
  );
};

export default SearchResultCardItem;
